<script>
    window.scrollTo(0, 0);

    import ContactForm from "../components/routes/ContactForm.svelte";
</script>

<section class="contact">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-xl-6 mb-4 mb-lg-0">
                <div class="contact-form">
                    <ContactForm/>
                </div>
            </div>
            <div class="col-lg-4 col-xl-6">
                <div class="contact-info">
                    <ul>
                        <li><i class="fas fa-map-marked-alt"></i> Valaliky, Kostolná 117/18, 044 13</li>
                        <li><i class="fas fa-clock"></i> Pon-Pia: 8:00 - 16:00</li>
                        <li><i class="fas fa-phone-alt"></i> <a href="tel:+421911022525">+421 911 022 525</a></li>
                        <li><i class="fas fa-envelope"></i> <a href="mailto:info@pneuin.sk">info@pneuin.sk</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .contact {
        padding: 3rem 0;
    }
    .contact-form {
        border-right: 1px solid var(--color-slate-200);
        padding-right: 2rem;
    }
    @media (max-width: 991.98px) {
        .contact-form {
            border-right: 0;
            padding-right: 0;
        }
    }
    .contact-info {
        font-family: Rubik, sans-serif;
        font-weight: 400;
    }
    .contact-info ul {
        list-style-type: none;
        padding-left: 0;
        color: var(--color-slate-500);
    }
    .contact-info ul li:not(:last-child) {
        padding-bottom: 1.5rem;
    }
    .contact-info i {
        font-size: 1.5rem;
        margin-right: 1rem;
        color: var(--color-slate-600);
    }
    .contact-info a {
        color: var(--color-slate-500);
    }
    .contact-info a:hover {
        color: var(--color-primary);
    }
</style>